export { View as Tab2022 } from './view'
